import React from 'react';
import Swiper from 'react-id-swiper';

import { Title } from 'components/typography';
import HighlightedText from 'components/highlightedText';
import SectionContainer from 'components/sectionContainer';
import { SWIPER_SETTINGS } from 'config';

import { MILESTONES } from './Milestones.constants';
import { getNumVisibleItems } from './Milestones.helpers';

import {
  milestoneItem,
  milestonesRow,
  milestonesSection,
  milestonesContainer,
  descriptionContainer,
  milestonesTitle,
} from './scss/Milestones.module.scss';

const Milestones = () => {
  const sliderSettings = {
    ...SWIPER_SETTINGS,
    effect: 'slide',
    spaceBetween: 80,
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {},
    autoplay: {
      delay: 15000,
    },
    slidesPerView: getNumVisibleItems(),
  };

  return (
    <section className={milestonesSection}>
      <SectionContainer className={descriptionContainer}>
        <Title
          size="xl"
          value={
            <span>
              We have built an organization that provides
              <HighlightedText value="innovative" /> solutions for the
              Agricultural sector in Nigeria.
            </span>
          }
        />
        <p>
          {`
            Our team of young, vibrant and ethical people seek to maximize the 
            value that farmers and other market participants derive from 
            their activities. This focus has led to the development and 
            deployment of a number of solutions which have resulted in gains 
            for Nigerian smallholder farmers, processors, exporters, investors 
            and the Nigerian economy at large, which is benefiting from a 
            growing commodities ecosystem. In this way, we are indeed 
            growing markets and connecting trade.
          `}
        </p>
      </SectionContainer>

      <SectionContainer className={milestonesContainer}>
        <Title
          className={milestonesTitle}
          fontStyle="regular"
          value="Our Milestones"
          size="xs"
        />
        <div className={milestonesRow}>
          <Swiper {...sliderSettings}>
            {MILESTONES.map((milestone, index) => (
              <div className={milestoneItem} key={`main-${index}`}>
                <h1>{milestone.year}</h1>
                <p>{milestone.description}</p>
              </div>
            ))}
          </Swiper>
        </div>
      </SectionContainer>
    </section>
  );
};

export default Milestones;
